import React from 'react';
import './Contact.css';

const Contact = ({ picture, name, surname, jobTitle, mail, description, imageSize }) => {
  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const senderName = formData.get('name').trim();
    const senderEmail = formData.get('email').trim();
    const subject = formData.get('subject').trim() || 'Contacting from your personal website';
    const message = formData.get('message').trim();
    const body = [
      message,
      '',
      `From: ${senderName}`,
      `Email: ${senderEmail}`,
    ].join('\n');

    window.location.href = `mailto:${mail}@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="contact-container">
      <div className="contact-details">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[var(--accent-green)]">
          Contact
        </p>
        <h1 className="contact-name mt-2 text-3xl font-bold text-[var(--text-primary)] md:text-4xl">{name} {surname}</h1>
        <h2 className="contact-job-title mt-1 text-xl font-semibold text-[var(--accent-gold)]">{jobTitle}</h2>
        <div className="contact-description mt-5 space-y-2 text-base leading-relaxed text-[var(--text-secondary)]">
            {description.map((description, index) => (
              <p key={index}>{description}</p>
            ))}
        </div>
        <form className="contact-form mt-6" onSubmit={handleSubmit}>
          <label className="contact-field">
            <span>Name</span>
            <input name="name" type="text" autoComplete="name" required />
          </label>
          <label className="contact-field">
            <span>Email</span>
            <input name="email" type="email" autoComplete="email" required />
          </label>
          <label className="contact-field">
            <span>Subject</span>
            <input name="subject" type="text" defaultValue="Contacting from your personal website" />
          </label>
          <label className="contact-field">
            <span>Message</span>
            <textarea name="message" rows="6" required />
          </label>
          <button className="contact-submit" type="submit">
            Send message
          </button>
        </form>
      </div>
      <div className="contact-picture">
        <img src={picture} alt={`${name} ${surname}`} style={{ width: imageSize, height: 'auto' }}/>
      </div>
    </div>
  );
};

export default Contact;
